export const googleSpreadKeys = {
  all: ["google-spread-sheet"],
  spreadsheet: options => [...googleSpreadKeys.all, options],
};
